import styled from 'styled-components';

// PM analitik P7b — E19 sayfa yerleşimi. Tek kaydırma: Özet sekmesinde içerik alanı kayar (sayfada tablo yok); liste sekmelerinde
// yalnız DataTable satırları kayar (kapsayıcı height:100% + min-height:0, tablo yüksekliği ölçülür).
export const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
  }
`;

export const Fixed = styled.div`
  flex-shrink: 0;
`;

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: ${({ $scroll }) => ($scroll ? 'auto' : 'hidden')};
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    overflow: visible;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
  flex-shrink: 0;
`;

export const Field = styled.div`
  width: ${({ $w }) => $w || '200px'};
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TableWrap = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    overflow: visible;
  }
`;

export const StateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 16px;
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  text-align: center;
`;

export const Note = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  margin-bottom: 10px;
  flex-shrink: 0;
`;
